module.exports = __webpack_public_path__ + "img/Desk Stationeryd11.6545edc9.jpg";